import * as _ from "lodash";

import { SubFormDefinition } from "../../../../../../../../utils/forms/components/FormSet";
import buildFormGridFields from "../../../../../../../../utils/forms/builders/build-form-grid-fields";
import { gameGroupFormDefinition, SCHEMA_NAMES } from "./GameGroups.constants";
import buildSchemaCompliantDefinition from "../../../../../../../../utils/forms/builders/build-schema-compliant-definition";

export const getNewGeneratedId = (key, configs) => {
    let flattenIds = configs.map(config => config.id);
    let newId = `${key}-00`;
    for (let i = 0; i <= 99; i++) {
        let generatedId = `${key}-${("0" + i).slice(-3)}`;
        if (!flattenIds.includes(generatedId)) {
            newId = generatedId;
            break;
        }
    }

    return newId;
};

const GAME_TYPES = {
    0: "Bingo",
    1: "Spins",
    2: "Lotto",
    3: "Keno"
};

const gameSubform = _.memoize(
    ({
        schema,
        groupsConfig,
        gameInstances,
        gameBundles,
        selectedGameInstances,
        gameTypes,
        currentSubsidiaryId
    }): SubFormDefinition[] => {
        let schemaItems = schema.items;
        schemaItems.properties["name"]["unique"] = groupsConfig.map(
            group => group.name
        );

        schemaItems.properties["bundles"] = {
            type: "array",
            items: {
                type: "integer"
            },
            minItems: 1,
            uniqueItems: true
        };

        const instacesFilteredByGameType = gameInstances["results"].filter(
            instance => {
                return gameTypes.includes(GAME_TYPES[instance.game.type]);
            }
        );

        const fullInstanceList: {
            value: string | number;
            label: string;
            appendex: string;
        }[] = _.uniqBy(
            instacesFilteredByGameType.map(game => {
                return {
                    value: game.identifier,
                    label: game.description,
                    appendex: GAME_TYPES[game.game.type].toLowerCase()
                };
            }),
            game => game.value
        );

        const fullBundlesList = gameBundles
            .map(bundle => {
                bundle.games = bundle.games.filter(game =>
                    gameTypes.includes(GAME_TYPES[game.type])
                );
                return bundle;
            })
            .filter(bundle => bundle.games.length > 0)
            .map(bundle => {
                let show_alias = bundle.alias.find(a=>a.subsidiary==currentSubsidiaryId)
                return {
                    value: bundle.id,
                    label: show_alias && show_alias.value && show_alias ? show_alias.value : bundle.name,
                    games: bundle.games
                };
            });

        const gamesTypeFormDefinition = gameGroupFormDefinition(
            fullInstanceList,
            selectedGameInstances,
            fullBundlesList
        );

        const formDefinition = buildSchemaCompliantDefinition(
            schemaItems,
            gamesTypeFormDefinition,
            [SCHEMA_NAMES.GROUPS]
        );

        return [
            {
                formType: "gameGroup",
                addLabel: "Add",
                emptyValue: {
                    id: getNewGeneratedId("ggroup", groupsConfig),
                    name: "",
                    game_instances: [],
                    game_bundles: []
                },
                fields: buildFormGridFields(schemaItems, formDefinition)
            }
        ];
    }
);

export default gameSubform;
